import Vue from 'vue';
import Router from 'vue-router';
import Home from './views/Home.vue';
import checkAuthHook from './lib/routerHooks';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/contacts',
      name: 'contacts',
      component: () => import(/* webpackChunkName: "contacts" */ './views/Contacts.vue'),
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/settings',
      name: 'settings',
      component: () => import(/* webpackChunkName: "settings" */ './views/Settings.vue'),
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/files',
      name: 'files',
      component: () => import(/* webpackChunkName: "files" */ './views/Files.vue'),
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/lessonsPage',
      name: 'lessons',
      component: () => import(/* webpackChunkName: "lessons" */ './views/Lessons.vue'),
      meta: {
        requiresAuth: true,
      },
      children: [
        {
          path: '/lessons',
          name: 'lessonsList',
          component: () => import(/* webpackChunkName: "lessons" */ './views/LessonsList.vue'),
          meta: {
            requiresAuth: true,
          },
        },
        {
          path: '/calendar',
          name: 'calendar',
          component: () => import(/* webpackChunkName: "lessons" */ './views/Calendar.vue'),
          meta: {
            requiresAuth: true,
          },
        },
      ],
    },
    {
      path: '/joins',
      name: 'joins',
      component: () => import(/* webpackChunkName: "joins" */ './views/Joins.vue'),
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/openPublic',
      name: 'public',
      component: () => import(/* webpackChunckName: "public" */ './views/Public.vue'),
      props: route => ({ query: route.query }),
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/money',
      name: 'money',
      component: () => import(/* webpackChunkName: "money" */ './views/MoneyPage.vue'),
      meta: {
        requiresAuth: true,
      },
      children: [{
        path: '/payments',
        name: 'payments',
        component: () => import(/* webpackChunkName: "money" */ './views/Payments.vue'),
        meta: {
          requiresAuth: true,
        },
        children: [
          {
            path: '/operations',
            name: 'operationsList',
            component: () => import(/* webpackChunkName: "money" */ './views/OperationsList.vue'),
            meta: {
              requiresAuth: true,
            },
          },
          {
            path: '/invoices',
            name: 'invoicesList',
            component: () => import(/* webpackChunkName: "money" */ './views/InvoicesList'),
            meta: {
              requiresAuth: true,
            },
          }],
      },
      {
        path: '/subscriptions',
        name: 'subscriptions',
        component: () => import(/* webpackChunkName: "money" */ './views/Subscriptions.vue'),
        meta: {
          requiresAuth: true,
        },
      }],
    },
    {
      path: '/auth/login',
      name: 'login',
      component: () => import(/* webpackChunkName: "login" */ './views/Login.vue'),
      meta: {
        requiresAuth: false,
      },
    },
    {
      path: '/auth/restorePassword',
      name: 'restorePassword',
      component: () => import(/* webpackChunkName: "login" */ './views/RestorePassword.vue'),
      meta: {
        requiresAuth: false,
      },
    },
    {
      path: '/auth/requestPassword',
      name: 'requestPassword',
      component: () => import(/* webpackChunkName: "login" */ './views/RestorePassword.vue'),
      meta: {
        requiresAuth: false,
        newUser: true,
      },
    },
    {
      path: '/auth/restoreMessageSent',
      name: 'RestoreMessageSent',
      component: () => import(/* webpackChunkName: "login" */ './views/RestoreMessageSent.vue'),
      meta: {
        requiresAuth: false,
      },
    },
    {
      path: '/auth/setPassword',
      name: 'setPassword',
      component: () => import(/* webpackChunkName: "login" */ './views/SetPassword.vue'),
      meta: {
        requiresAuth: false,
      },
    },
    {
      path: '/auth/passwordSet',
      name: 'passwordSet',
      component: () => import(/* webpackChunkName: "login" */ './views/PasswordSet.vue'),
      meta: {
        requiresAuth: false,
      },
    },
    {
      path: '/notFound',
      name: 'notFound',
      component: () => import(/* webpackChunkName: "notFound" */ './views/NotFoundPage.vue'),
      meta: {
        requiresAuth: false,
        loadBaseInfo: false,
      },
    },
  ],
});

router.beforeEach(checkAuthHook);

export default router;
